import { render, staticRenderFns } from "./ClientsConfig.vue?vue&type=template&id=123f9d21"
import script from "./ClientsConfig.vue?vue&type=script&lang=js"
export * from "./ClientsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123f9d21')) {
      api.createRecord('123f9d21', component.options)
    } else {
      api.reload('123f9d21', component.options)
    }
    module.hot.accept("./ClientsConfig.vue?vue&type=template&id=123f9d21", function () {
      api.rerender('123f9d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/ClientsConfig.vue"
export default component.exports